import { createContext } from 'react';
import { getWindow } from '@fluentui/react';

/* istanbul ignore file */ var _getWindow;
var noop = function() {
    return undefined;
};
var AppContext = /*#__PURE__*/ createContext({
    navigate: noop,
    location: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location,
    user: {
        loading: false,
        signedIn: false
    },
    searchProps: {
        onSearch: noop,
        filters: [],
        isSearchInHero: false
    },
    openSignInModal: noop,
    openPanelKey: '',
    setOpenPanelKey: noop,
    unifiedExperience: false
});

export { AppContext };
